import { forwardRef } from "react";
import { IMaskInput } from "react-imask";

interface Props {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
  onMaxLengthAttempt?: () => void;
}
/**
 * Adapted from
 * https://mui.com/material-ui/react-text-field/#integration-with-3rd-party-input-libraries
 */
export const MaskedPhoneInput = forwardRef<HTMLElement, Props>((props, ref) => {
  const { onChange, name, onMaxLengthAttempt, ...rest } = props;
  // Helper to count digits
  const countDigits = (value: string) => (value.match(/\d/g) ?? []).length;

  return (
    <IMaskInput
      {...rest}
      mask="(#00) 000-0000"
      definitions={{
        "#": /[2-9]/,
      }}
      inputRef={ref}
      overwrite={false}
      onAccept={(value: string) => {
        onChange({ target: { name, value } });
      }}
      onKeyDown={(event) => {
        const input = event.currentTarget as HTMLInputElement;
        const value = input.value ?? "";
        const digits = countDigits(value);
        const isDigit = event.key >= "0" && event.key <= "9";
        if (isDigit && digits >= 10) {
          if (onMaxLengthAttempt) {
            onMaxLengthAttempt();
          }

          event.preventDefault();
        }
      }}
    />
  );
});

MaskedPhoneInput.displayName = "MaskedPhoneInput";

MaskedPhoneInput.defaultProps = {
  onMaxLengthAttempt: undefined,
};
